import { render, staticRenderFns } from "./messageManagement.vue?vue&type=template&id=ff199d1e&scoped=true&"
import script from "./messageManagement.vue?vue&type=script&lang=js&"
export * from "./messageManagement.vue?vue&type=script&lang=js&"
import style0 from "./messageManagement.vue?vue&type=style&index=0&id=ff199d1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff199d1e",
  null
  
)

export default component.exports